export enum CheckoutStage {
  AGREEMENTS = "AGREEMENTS",
  DELIVERY = "DELIVERY",
  DISCOUNTS = "DISCOUNTS",
  ITEMS = "ITEMS",
  ORDER = "ORDER",
  PURCHASER = "PURCHASER",
}
